const Contact = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <script 
    src="https://kit.fontawesome.com/a6874c76aa.js" 
    crossorigin="anonymous"></script>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300&display=swap" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css2?family=Ubuntu+Condensed&display=swap" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap" rel="stylesheet">

    <link rel="stylesheet" href="./styles/common.css"/>
    <link rel="stylesheet" href="./styles/nav.css"/>
    <link rel="stylesheet" href="./styles/footer.css"/>
    <link rel="stylesheet" href="./styles/skewed-header.css"/>
    <link rel="stylesheet" href="./styles/page-container.css"/>
    <link rel="stylesheet" href="./styles/helpers.css"/>
    <link rel="stylesheet" href="./styles/contact.css"/>
    <link rel="stylesheet" href="./styles/form.css"/>
    <link rel="stylesheet" href="./styles/buttons.css"/>
    <link rel="stylesheet" href="./styles/media-queries.css"/>
    
    
    
    
    <title>Contact Us</title>
</head>
<body>
<div class="skewed-header">
    <div class="header-bg" style="background-image: url('/images/backgrounds/contact.jpg');"></div>

    <div class="skewed-header-wrapper">
        <div class="skewed-header-content">
            <div class="heading-wrapper">
                <h1>Contact Us</h1>
            </div>

            <div class="links-wrapper">
                <div class="nav-link">
                    <a href="index.html">Home</a> 
                </div>
                <div class="nav-link">
                    <a href="about.html">About</a>
                </div>
                <div class="nav-link">
                    <a href="menu.html">Menu</a>
                </div>
                <div class="nav-link">
                    <a href="contact.html">Contact</a>  
                </div>                 
            </div>

        </div>
    </div>
</div>

<div class="page-container">
    <div class="contact-grid-wrapper">
        <div class="company-metadata-sidebar-wrapper">
            <div class="logo">
                <img src="./images/logos/decamp-fantastic-fries-logo-dark.png" alt="Logo Dark">
            </div>
            <div class="company-details-wrapper">
                <i class="fa-solid fa-location-dot"></i>
                <div>
                    321 Any Ave <br>Dromilly, TR, 000000
                </div>
            </div>
            <div class="company-details-wrapper">
                <i class="fa-solid fa-phone-volume"></i>
                <div>
                    555 555 5555
                </div>
            </div>
            <div class="company-details-wrapper">
                <i class="fa-regular fa-clock"></i>
                <div>
                    10AM - MIDNIGHT
                </div>
            </div>
        </div>
        <div class="form">
            <div class="form-group">
                <input type="text" id="fullName" placeholder="Your Name">
                <label for="fullName"> Your Name</label>
            </div>
            <div class="form-group">
                <input type="email" id="email" placeholder="Your Email">
                <label for="email"> Email</label>
            </div>
            <div class="form-group">
                <textarea name="message" id="message" placeholder="Message"></textarea>
                    <label for="message"> Message</label>
            </div>
            <div class="spacer10"></div>
            <div class="center-btn-wrapper">
                <button type="submit" class="btn">Send</button>
            </div>
        </div>
    </div>
</div>
<div class="spacer60"></div>
<div class="footer">
    <div class="logo-footer">
        <img src="images/logos/decamp-fantastic-fries-logo-white.png" alt="Logo">
    </div>
    <div class="footer-phone-hours">
        <span class="phone">
            555 555 5555
        </span>
        <span class="hours">
            10 am - midnight
        </span>
    </div>
    <div class="links-wrapper">
        <div class="nav-link">
            <a href="index.html">Home</a> 
        </div>
        <div class="nav-link">
            <a href="about.html">About</a>
        </div>
        <div class="nav-link">
            <a href="menu.html">Menu</a>
        </div>
        <div class="nav-link">
            <a href="contact.html">Contact</a>  
        </div>
    </div>
    <div class="social-media-icons-wrapper">
        <a href="#">
            <i class="fa-brands fa-instagram"></i>
        </a>
        <a href="#">
            <i class="fa-brands fa-twitter"></i>
        </a>
        <a href="#">
            <i class="fa-brands fa-facebook"></i>
        </a>
    </div>
    <div class="copyright-wrapper">
        &copy; 2022 DevCamp &#124; All rights reserved
    </div>
</div>
</body>
</html>`

export default Contact;